import { render, staticRenderFns } from "./yearcard.vue?vue&type=template&id=4f50efda&scoped=true"
import script from "./yearcard.vue?vue&type=script&lang=js"
export * from "./yearcard.vue?vue&type=script&lang=js"
import style0 from "./yearcard.vue?vue&type=style&index=0&id=4f50efda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50efda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f50efda')) {
      api.createRecord('4f50efda', component.options)
    } else {
      api.reload('4f50efda', component.options)
    }
    module.hot.accept("./yearcard.vue?vue&type=template&id=4f50efda&scoped=true", function () {
      api.rerender('4f50efda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/yearcard.vue"
export default component.exports